import React, { Component } from 'react';
import { Link } from "react-router-dom";
import _ from "lodash";
import HsForm from 'react-hubspot-form'
import Header from "./Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MetaTags from 'react-meta-tags';

class TutorialPage extends Component {


  render() {

    return (
      <div className="page tutorial-page">
        <MetaTags>
          <title>How To Use Guide, Euro Film Launches</title>
          <meta name="description" content="A simple 'how to' guide, so you can find out when any film is opening in European cinemas over the next twelve months" />
          <meta property="og:title" content="How To Use Guide, Euro Film Launches" />
        </MetaTags>
        <Header authed={this.props.authed} logout={this.props.logout} setRedirect={this.props.setRedirect}/>
        <div className="content">
          <div className="title">How to use the site</div>
          <div className="subtitle">To see calendar details of when & where a film is being released in all relevant territories:</div>
          <div className="text">Enter the title in English or your local language in the ‘Movie Title’ drop down menu, click on the highlighted title and the information will appear below.</div>
          <div className="text">Or select the English language version of the title from the ‘Movie Title’ drop down menu, click on the highlighted title and the information will appear below.</div>
          <div className="image"><img src="Sc1.jpg" /></div>
          <div className="subtitle">To see calendar details of all films being released by a distributor in all relevant territories:</div>
          <div className="text">Enter the name of the distributor in the ‘Distributor’ drop down menu, click on the highlighted title and the information will appear below.</div>
          <div className="text">Or select the name of the distributor from the ‘Distributor’ drop down menu, click on the highlighted title and the information will appear below.</div>
          <div className="image"><img src="Sc2.jpg" /></div>
          <div className="subtitle">To see calendar details of all films being released in a single territory:</div>
          <div className="text">Select the relevant country abbreviation from the ‘Country’ drop down menu, click on the highlighted country abbreviation and the information will appear below.</div>
          <div className="image"><img src="Sc3.jpg" /></div>
          <div className="subtitle">To extend the length of the calendar for all searches:</div>
          <div className="text">Click on the calendar icon, select the length of time for your search, click on ‘Apply’.</div>
          <div className="image"><img src="Sc4.jpg" /></div>
        </div>
      </div>
    );
  }

}

export default TutorialPage;












// WEBPACK FOOTER //
// ./src/components/TutorialPage.js